export type XtMessage = {
  id: number;
  opened: number;
  clicked: number;
  create_time: number;
  expiration_time: number;
  message: {
    title: string;
    alert: string;
    icon: string;
    style: string[];
  };
};

type XtParams = {
  id?: number;
  open?: number;
  click?: number;
  limit?: number;
  offset?: number;
  opened?: number;
  clicked?: number;
  expired?: number;
};

type XtSucces = {
  badge: number;
  count: number;
  more: boolean;
  items: XtMessage[];
};

export type XtremePushGlobal = {
  xtremepush: (
    type: string,
    method: string,
    params: XtParams,
    onSuccess: (obj: XtSucces) => void,
    onError: (obj: Record<string, string>) => void
  ) => void;
};

export type XtremePushGlobalBadge = {
  xtremepush: (type: string, handler: () => void) => void;
};

export enum MessageTabs {
  ALL = 'All',
  UNREAD = 'Unread',
  READ = 'Read',
}
